/**
 * Created by juraj.homola on 17. 1. 2017.
 */

export const BRINGFRIENDS_TAB_RULES = 1;
export const BRINGFRIENDS_TAB_INVITATIONS = 2;
export const BRINGFRIENDS_TAB_OVERVIEW = 3;
